<template>
	<div class="cbs-range-masked-input flex flex-wrap">
		<div class="w-full sm:flex-1 sm:mr-3 mb-3 sm:mb-0">
			<cbs-masked-input
				v-bind="$attrs"
				:value="value[0]"
				:placeholder="beginPlaceholder"
				class="cbs-range_masked-input__item mb-3 last:mb-0 vs-inputx vs-input--input normal"
				@input="val => $emit('input', [val, value[1]])"
			/>
		</div>

		<div class="w-full sm:flex-1">
			<cbs-masked-input
				v-bind="$attrs"
				:value="value[1]"
				:placeholder="endPlaceholder"
				class="cbs-range_masked-input__item mb-3 last:mb-0 vs-inputx vs-input--input normal"
				@input="val => $emit('input', [value[0], val])"
			/>
		</div>
	</div>
</template>

<script>
import _ from "lodash";

export default {
	name: "CbsRangeMaskedInput",
	inheritAttrs: false,
	props: {
		value: {
			type: Array,
			required: true,
			validator: prop => {
				if (!_.isEmpty(prop)) {
					if (prop.length !== 2) {
						return false;
					}
				}
				return true;
			}
		},
		beginPlaceholder: {
			type: String,
			default: "Start value"
		},
		endPlaceholder: {
			type: String,
			default: "End value"
		}
	}
};
</script>
